<template>
    <div class="h-full">
        <a
            :href="url"
            class="block w-full h-full"
        >
            <BrandedCard
                class="h-full min-h-32 flex flex-col md:flex-row justify-between items-start gap-4"
            >
                <div class="w-full order-2 md:order-1 space-y-1">
                    <div class="font-semibold text-lg">
                        {{ service.title }}
                    </div>
                    <div class="flex items-center gap-4">
                        <div
                            class="text-sm text-gray-600 flex items-center gap-1"
                        >
                            <Icon
                                name="clock"
                                class="w-3.5 h-3.5"
                            />
                            <span
                                >{{ service.durationInMinutes }}
                                {{
                                    localizer.translate(
                                        TextTokenEnum.Meeting_Mins,
                                    )
                                }}</span
                            >
                        </div>
                        <div
                            v-if="service.shouldDisplayPaidIcon()"
                            class="text-sm text-gray-600 flex items-center gap-1"
                        >
                            <Icon
                                name="dollar-sign"
                                class="w-3.5 h-3.5"
                            />
                            <span>
                                {{
                                    localizer.translate(
                                        TextTokenEnum.Meeting_Paid,
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            v-if="service.shouldDisplayGroupIcon()"
                            class="text-sm text-gray-600 flex items-center gap-1"
                        >
                            <Icon
                                name="users"
                                class="w-3.5 h-3.5"
                            />
                            <span>
                                {{
                                    localizer.translate(
                                        TextTokenEnum.Meeting_Group,
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            v-if="service.isRecurring()"
                            class="text-sm text-gray-600 flex items-center gap-1"
                        >
                            <Icon
                                name="arrow-rotate"
                                class="w-3.5 h-3.5"
                            />
                            <span>
                                {{
                                    localizer.translate(
                                        TextTokenEnum.Meeting_Recurring,
                                    )
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="text-sm text-gray-600">
                        {{ service.description }}
                    </div>
                    <div
                        class="flex justify-end items-center gap-1 text-sm text-gray-600"
                    >
                        <span> Select </span>
                        <Icon
                            name="arrow-right"
                            class="w-3 h-3 text-gray-500"
                        />
                    </div>
                </div>
                <template v-if="false">
                    <div
                        class="flex justify-center items-center order-1 md:order-2"
                    >
                        <div class="overflow-hidden rounded-lg2">
                            <Image
                                src="/static/images/booking-form/product.jpeg"
                                :alt="service.title"
                                class="min-w-20 min-h-20 max-w-20 max-h-20 lg:min-w-28 lg:min-h-28 lg:max-w-28 lg:max-h-28 object-cover"
                            />
                        </div>
                    </div>
                </template>
            </BrandedCard>
        </a>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import Service from '@/App/Service/Entity/Service'
    import Icon from '@/Shared/Component/Icon.vue'
    import BrandedCard from '@/BookingForm/BookingForm/Component/BrandedCard.vue'
    import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
    import Image from '@/Shared/Component/Image.vue'

    const props = defineProps({
        companySlug: {
            type: String,
            required: true,
        },
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        localizer: {
            type: Object as PropType<LocalizerService>,
            required: true,
        },
    })

    const url = new UrlFactory().makeBookingFormServiceUrl(
        props.companySlug,
        props.service.slug,
        props.localizer.getLocale(),
    )
</script>
